import { Prose } from "@liberetech/design-system";
import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./CardKleeProse.module.css";

const CardKleeProse: React.FC<CardKleeProseProps> = ({
  className,
  children,
}) => (
  <Prose compact className={classNames(className, styles.prose)}>
    {children}
  </Prose>
);

type CardKleeProseProps = { className?: string; children: ReactNode };

export default CardKleeProse;
